import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Navigation Bar */}
      <nav className="landing-nav">
        <div className="nav-left">
          <img src="/vibely-logo.svg" alt="Vibely" className="nav-logo" data-testid="landing-logo" />
        </div>
        <div className="nav-center">
          <a href="#features" className="nav-link">Features</a>
          <a href="#how-it-works" className="nav-link">How It Works</a>
        </div>
        <div className="nav-right">
          <button className="nav-signin" onClick={() => navigate('/login')}>Sign in</button>
          <button className="nav-cta" onClick={() => navigate('/login')}>Get Started</button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-left">
            <h1 className="hero-title">
              Think, plan, and track
            </h1>
            <h2 className="hero-subtitle">all in one place</h2>
            <p className="hero-description">
              Efficiently manage your tasks and boost productivity with AI-powered meeting transcription and smart team collaboration.
            </p>
            <button className="hero-cta" onClick={() => navigate('/login')}>
              Get Started Free
            </button>
          </div>
          
          <div className="hero-right">
            <div className="hero-visual">
              {/* Sticky Note */}
              <div className="sticky-note">
                <div className="pin"></div>
                <p>Take notes to keep track of crucial details and accomplish more tasks with ease.</p>
              </div>
              
              {/* Checkbox Card */}
              <div className="checkbox-card">
                <div className="checkbox checked"></div>
              </div>
              
              {/* Reminders Card */}
              <div className="reminders-card">
                <div className="reminder-dots">
                  <span className="dot active"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
                <p className="reminder-label">Reminders</p>
              </div>
              
              {/* Meeting Card */}
              <div className="meeting-card">
                <p className="meeting-label">Today's Meeting</p>
                <p className="meeting-time">13:00 - 13:45</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <h2 className="features-title">Powerful Features for Team Success</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📋</div>
            <h3>Kanban Board</h3>
            <p>Visualize your workflow with drag-and-drop task management</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">👥</div>
            <h3>Team Collaboration</h3>
            <p>Work together seamlessly with role-based permissions</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">✅</div>
            <h3>Approval Workflow</h3>
            <p>Smart approval system for team changes and updates</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">💬</div>
            <h3>Task Comments</h3>
            <p>Discuss tasks with threaded comments and file sharing</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🎙️</div>
            <h3>Meeting Transcription</h3>
            <p>AI-powered transcription for all your team meetings</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🔔</div>
            <h3>Real-time Notifications</h3>
            <p>Stay updated with instant notifications and alerts</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section">
        <h2 className="section-title">How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Create Your Team</h3>
            <p>Set up your workspace and invite team members</p>
          </div>
          
          <div className="step">
            <div className="step-number">2</div>
            <h3>Organize Tasks</h3>
            <p>Create and assign tasks using the intuitive Kanban board</p>
          </div>
          
          <div className="step">
            <div className="step-number">3</div>
            <h3>Collaborate & Track</h3>
            <p>Work together, comment on tasks, and track progress</p>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="footer-cta">
        <h2>Ready to boost your team's productivity?</h2>
        <button className="footer-cta-button" onClick={() => navigate('/login')}>
          Get Started Now
        </button>
      </section>
    </div>
  );
};

export default LandingPage;
